(function () {
    'use strict';

    angular.module('app.discounts')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'discounts',
                config: {
                    url: '/discounts',
                    title: 'İndirimler',
                    abstract: true,
                    templateUrl: 'app/discounts/discounts.html'
                }
            },
            {
                state: 'discounts.list',
                config: {
                    templateUrl: 'app/discounts/discounts.list.html',
                    controller: 'DiscountsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'İndirim Listesi',
                    settings: {
                        nav: 10,
                        name: 'discounts.list',
                        topName: 'sales',
                        content: 'İndirim Listesi',
                        resource: 'menu.discounts.list'
                    }
                }
            },
            {
                state: 'discounts.add',
                config: {
                    templateUrl: 'app/discounts/discounts.add.html',
                    controller: 'DiscountsAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'İndirim Ekle',
                    settings: {
                        topName: 'discounts.list',
                        resource: 'menu.discounts.add'
                    }
                }
            },
            {
                state: 'discounts.edit',
                config: {
                    templateUrl: 'app/discounts/discounts.edit.html',
                    controller: 'DiscountsEditController',
                    controllerAs: 'vm',
                    url: '/edit/:Id',
                    title: 'İndirim Düzenle',
                    settings: {
                        topName: 'discounts.list',
                        resource: 'menu.discounts.edit'
                    }
                }
            },
            {
                state: 'discounts.detail',
                config: {
                    templateUrl: 'app/discounts/discounts.detail.html',
                    controller: 'DiscountsDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:Id',
                    title: 'İndirim Detay',
                    settings: {
                        topName: 'discounts.list',
                        resource: 'menu.discounts.detail'
                    }
                }
            }
        ];
    }
})();